<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Century Gothic', Helvetica, Arial, sans-serif;
}
li{
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue